import React from "react";
import { useRoutes } from "react-router-dom";
import { PrivacyPolicy } from "../component/screen";

export default function Router() {
  return useRoutes([
    {
      path: "",
      element: <PrivacyPolicy />,
    },
    {
      path: "privacyPolicy",
      element: <PrivacyPolicy />,
    },
  ]);
}
